import { Script } from '@calendly/react-script-tag'
import { useSelector } from 'react-redux'
import { SafeSuspense } from '@calendly/safe-suspense'

import { eventTypeSelector } from 'root-api'
import { timeNotationSelector, eventSelector } from 'selectors'

const IntercomConfirmation = () => {
  const {
    scheduled_profile: { name: profileName },
    start_time: startTime
  } = useSelector(eventSelector)
  const { name: eventName } = useSelector(eventTypeSelector)
  const locale = useSelector((state) => state.scheduling.invitee.locale)
  const timezone = useSelector((state) => state.scheduling.invitee.timezone)
  const timeNotation = useSelector(timeNotationSelector)

  return (
    <SafeSuspense fallback={null}>
      <Script src="https://js.intercomcdn.com/messenger-sheet-library.latest.js">
        {
          () => {
            INTERCOM_MESSENGER_SHEET_LIBRARY.submitSheet({
              profile_name: profileName,
              event_name: eventName,
              start_time: startTime,
              timezone,
              locale,
              time_notation: timeNotation
            })

            return null
          }
        }
      </Script>
    </SafeSuspense>
  )
}

export default IntercomConfirmation
